/* eslint-disable */
// Generated by infra/scripts/generate-aws-config.js — do not commit secrets.
// Prefer this file over aws-exports.js when present (see App.js).

const awsmobile = {
  "aws_project_region": "eu-west-2",
  "aws_cognito_identity_pool_id": "eu-west-2:502b001f-8f13-4438-923c-42373c809d56",
  "aws_cognito_region": "eu-west-2",
  "aws_user_pools_id": "eu-west-2_iBzkz2lVD",
  "aws_user_pools_web_client_id": "2obstko8g4uvkn51h0s9ehm338",
  "oauth": {
    "domain": "cyf-dev2.auth.eu-west-2.amazoncognito.com",
    "scope": [
      "phone",
      "email",
      "openid",
      "profile",
      "aws.cognito.signin.user.admin"
    ],
    "redirectSignIn": "https://dev2.app.compareyourfootprint.com/",
    "redirectSignOut": "https://dev2.app.compareyourfootprint.com/",
    "responseType": "code"
  },
  "federationTarget": "COGNITO_USER_AND_IDENTITY_POOLS",
  "aws_cognito_username_attributes": [
    "EMAIL"
  ],
  "aws_cognito_social_providers": [
    "GOOGLE"
  ],
  "aws_cognito_signup_attributes": [
    "EMAIL"
  ],
  "aws_cognito_mfa_configuration": "OPTIONAL",
  "aws_cognito_mfa_types": [
    "TOTP"
  ],
  "aws_cognito_password_protection_settings": {
    "passwordPolicyMinLength": 8,
    "passwordPolicyCharacters": []
  },
  "aws_cognito_verification_mechanisms": [
    "EMAIL"
  ],
  "aws_cloud_logic_custom": [
    {
      "name": "cyfApi",
      "endpoint": "https://api.dev2.app.compareyourfootprint.com",
      "region": "eu-west-2"
    }
  ]
};

export default awsmobile;
